import SiteLogo from '@/components/layouts/common/SiteLogo';

export default {
  components: {
    'site-logo': SiteLogo
  }
};



// WEBPACK FOOTER //
// ./src/mixins/Layout.js